import React, { useEffect, useRef, useState, useCallback, useMemo } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { TraitementService } from "../../Services/TraitementService";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  List,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
  message,
} from "antd";
import {
  CheckCircleOutlined,
  CheckSquareOutlined,
  CloseCircleOutlined,
  CloseSquareOutlined,
  DeleteFilled,
  EditOutlined,
  ExclamationCircleOutlined,
  EyeOutlined,
  ImportOutlined,
  PlusCircleOutlined,
  UpCircleOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import dayjs from "dayjs";
import * as XLSX from "xlsx";
import { PrestationsService } from "../../Services/PrestationsService";
import { BpiService } from "../../Services/BpiService";
import ModalBM from "../Modal_Doc/ModalBM";
import Draggable from "react-draggable";
import { DocumentService } from "../../Services/DocumentService";


const { Option } = Select;

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: "100%", cursor: "move" }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};

const TraitementFacture = () => {
  const numenreg = useParams().numenreg;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const traitementFactureService = useMemo(() => new TraitementService(), []);
  const prestationService = useMemo(() => new PrestationsService(), []);
  const documentService = useMemo(() => new DocumentService(), []);
  const bpiService = useMemo(() => new BpiService(), []);

  const [dateModified, setDateModified] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [acteSelected, setActeSelected] = useState(null);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [tableData1, setTableData1] = useState([]);
  const [secondTableData, setSecondTableData] = useState([]);
  const [filteredSecondTableData, setFilteredSecondTableData] =
    useState(secondTableData);
  const [filteredData, setFilteredData] = useState(tableData);
  const [searchSecondTableValue, setSearchSecondTableValue] = useState("");
  const [tauxpcData, setTauxpcData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [selectedNumDoc, setSelectedNumDoc] = useState(null);
  const [totalMontdoc, setTotalMontdoc] = useState(0);
  const [editDate, setEditDate] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedticket, setSelectedticket] = useState(false);
  const [paramsDetails, setParamsDetails] = useState(null);
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);
  const [detailsData, setDetailsData] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isSaveButtonEnabled, setIsSaveButtonEnabled] = useState(false);
  const [numfourn, setNumfourn] = useState(null);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);
  const [isTarifJour, setIsTarifJour] = useState(false);
  const [importedData, setImportedData] = useState([]);
  const [totals, setTotales] = useState({ totalLines: 0, totalCalculated: 0 });
  const [pageSize, setPageSize] = useState(10);
  const [anomaliesData, setAnomaliesData] = useState([]);
  const [isAnomaliesModalOpen, setIsAnomaliesModalOpen] = useState(false);
  const [totales, setTotals] = useState({
    qteTotal: 0,
    freelTotal: 0,
    qpmutTotal: 0,
    ticketTotal: 0,
    qpassurTotal: 0,
    fexclusTotal: 0,
    ajustmtTotal: 0,
  });
  const [currentFormData, setCurrentFormData] = useState({});
  const [detailData, setDetailData] = useState({});
  const [loadingActes, setLoadingActes] = useState(false);
  const [loadingTable1, setLoadingTable1] = useState(false);
  const [loadingTable2, setLoadingTable2] = useState(false);
  const [montantBon, setMontantBon] = useState(0);
  const [montverse, setMontVerse] = useState(0);
  const [isActeSelectable, setIsActeSelectable] = useState(false);
  const [isExclus, setIsExclus] = useState(false);
  const [isFieldsEnabled, setIsFieldsEnabled] = useState(false);
  const [isFieldsEnabledFreel, setIsFieldsEnabledFreel] = useState(false);
  const [persistedLignePrestations, setPersistedLignePrestations] = useState(
    []
  );

  const [ecart, setEcart] = useState(montantBon);
  const location = useLocation();
  const { record } = location.state || {};

  const loadData = useCallback(async () => {
    setLoadingTable1(true);
    if (record && record.numenreg) {
      try {
        const data = await traitementFactureService.getOneListTraitementFact(
          record.numenreg
        );
        setSecondTableData(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des données", error);
      } finally {
        setLoadingTable1(false);
      }
    }
  }, [record, traitementFactureService]);

  const loadDataFourn = useCallback(async () => {
    setLoadingTable2(true);
    if (record && record.numenreg) {
      try {
        const data = await traitementFactureService.getOneListTraitementFourn(
          record.numfourn
        );
        setTableData(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des données", error);
      } finally {
        setLoadingTable2(false);
      }
    }
  }, [record, traitementFactureService]);

  const loadDatapresta = async () => {
    if (record && record.numenreg) {
      try {
        const data = await prestationService.getLignePrestations(
          record.codespe
        );
        setModalData(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des données", error);
      }
    }
  };
  const loadParams = useCallback(async () => {
    if (record && record.numenreg) {
      try {
        const data = await traitementFactureService.getParamComptable();
        setParamsDetails(data);
        setNumfourn(record.numfourn);
      } catch (error) {
        console.error("Erreur lors de la récupération des données", error);
      }
    }
  }, [record, traitementFactureService]);

  const loadExercise = useCallback(async () => {
    if (record && record.numenreg) {
      try {
        const data = await traitementFactureService.getExercices();
        // Si besoin, traitez les données ici
        // Exemple : setExercices(data);
      } catch (error) {
        console.error("Erreur lors de la récupération des exercices", error);
      }
    }
  }, [record, traitementFactureService]);

  useEffect(() => {
    loadData();
    loadDataFourn();
    loadParams();
    loadExercise();
  }, [record, loadData, loadDataFourn, loadParams, loadExercise]);
  const regenererLignes = async () => {
    if (selectedRowKeys.length === 0) {
      message.warning("Veuillez sélectionner au moins une ligne à régénérer.");
      return;
    }

    const lignesARegenerer = secondTableData.filter((ligne) =>
      selectedRowKeys.includes(ligne.numdoc)
    );

    try {
      const traitementService = new TraitementService();
      await traitementService.RegereDonnee(lignesARegenerer);

      // Exemple de mise à jour de l'état, adaptez selon votre logique
      const newData = secondTableData.filter(
        (ligne) => !selectedRowKeys.includes(ligne.numdoc)
      );
      setSecondTableData(newData);
      setTableData([...tableData, ...lignesARegenerer]);
      setSelectedRowKeys([]);

      message.success("Les lignes ont été régénérées avec succès.");
    } catch (error) {
      message.error("Erreur lors de la régénération des lignes.");
    }
  };

  const totalqpmut = secondTableData.reduce(
    (total, item) => total + Number(item.qpmut),
    0
  );
  const totalticket = secondTableData.reduce(
    (total, item) => total + Number(item.ticket),
    0
  );

  const totalMutuel = secondTableData.reduce(
    (total, item) => total + Number(item.qpassur),
    0
  );

  const freelValue = record.freel || 0;

  const ecartSecondTable =
    freelValue - (totalqpmut + totalticket + totalMutuel);

  const showModalWithData = async (myrecord) => {
    setIsDetailModalOpen(true);
    const { numdoc } = myrecord;

    const numfourn = record.numfourn;
    const numfournPrefix = numfourn ? numfourn.substring(0, 2) : null;
    console.log("numfourn complet :", numfourn);
    try {
      const [detailBpi, lignePrestations] = await Promise.all([
        bpiService.GetDetailBpi(numdoc),
        numfournPrefix
          ? prestationService.getLignePrestations(numfournPrefix)
          : Promise.resolve([]),
      ]);

      setSelectedNumDoc(detailBpi.numdoc);
      setDetailData(detailBpi);
      const ticket_paye = detailBpi.ticket_paye;
      setSelectedticket(ticket_paye);
      setMontVerse(detailBpi.montverse || 0);
      setMontantBon(detailBpi.montdoc || 0);

      // Stocker les lignes de prestation dans un état persistant
      setPersistedLignePrestations(lignePrestations);
      // Valeur de 'freel' pour la facture actuelle
      const totalMontdoc = secondTableData.reduce(
        (total, item) => total + Number(item.montdoc),
        0
      );
      const nombreDeLignes = secondTableData.length;
      const ecartsecond = freelValue - totalMontdoc;

      setModalData({
        detailBpi,
        lignePrestations,
        freelValue,
        totalMontdoc,
        nombreDeLignes,
        ecartsecond,
      });

      const montdocValue = detailBpi.montdoc || 0;
      setIsActeSelectable(!!montdocValue);
      setIsFieldsEnabledFreel(!!montdocValue);
      setIsFieldsEnabled(!!montdocValue);

      if (detailBpi.actes && detailBpi.actes.length > 0) {
        setTableData1(detailBpi.actes);
      } else {
        setTableData1([]);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  const handleDisplayAnomaliesFacture = async (numFact) => {
    try {
      const anomalies = await documentService.getAnomaliesTraitementFacture(numFact);
      setAnomaliesData(anomalies);

      if (!anomalies || anomalies.length === 0) {
        Modal.info({
          title: "Aucune anomalie détectée",
          content: "Aucune anomalie n'a été trouvée pour cette facture.",
        });
        return;
      }

      Modal.info({
        title: "Liste des anomalies détectées",
        width: 700,
        content: (
          <Table
            dataSource={anomalies}
            rowKey="numdoc"
            pagination={false}
            columns={[
              { title: "N° Bon", dataIndex: "numdoc", key: "numdoc" },
              { title: "LQP.IPM", dataIndex: "lqpmut", key: "lqpmut" },
              { title: "LQP.PART", dataIndex: "lticket", key: "lticket" },
              { title: "QP.IPM", dataIndex: "qpmut", key: "qpmut" },
              { title: "QP.PART", dataIndex: "ticket", key: "ticket" },
              { title: "Écart", dataIndex: "ecart", key: "ecart" },
              {
                title: "",
                key: "action",
                render: (_, record) => (
                  <Button
                    style={{ padding: "0px 8px", margin: "0px 8px", fontSize: "12px", color: "white", backgroundColor: "#010f1c" }}
                    onClick={() => {
                      setFilteredSecondTableData(secondTableData.filter(item => item.numdoc === record.numdoc));
                      // Patch la valeur dans le champ de recherche global
                      setSearchSecondTableValue(record.numdoc);
                      // handleSearch1(record.numdoc);
                      Modal.destroyAll(); // Ferme la modale des anomalies
                    }}
                  >
                    Voir
                  </Button>
                ),
              },
            ]}
          />
        ),
      });

      setIsAnomaliesModalOpen(true);
    } catch (error) {
      console.error("Erreur lors de la récupération des anomalies :", error);
    }
  };

  const handleNumDocChange = async (numdoc) => {
    try {
      const detailBpi = await bpiService.GetDetailBpi(numdoc);
      setDetailData(detailBpi);
      setSelectedticket(detailBpi.ticket_paye);
      setMontVerse(0);
      setMontantBon(detailBpi.montdoc || 0);
      setSelectedNumDoc(numdoc);

      // Utiliser les lignes de prestation persistées au lieu de faire un nouvel appel API
      setTableData1(detailBpi.actes || []);
      setIsActeSelectable(!!detailBpi.montdoc);
      setIsFieldsEnabledFreel(!!detailBpi.montdoc);
      setIsFieldsEnabled(!!detailBpi.montdoc);

      // Mettez à jour uniquement les parties spécifiques de `modalData`
      setModalData((prevData) => ({
        ...prevData,
        detailBpi,
        lignePrestations: persistedLignePrestations, // Réutiliser les données persistées
      }));
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des détails du BPI :",
        error
      );
    }
  };

  const formatNumberWithSeparator = (number) => {
    if (number === null || number === undefined) {
      return "0"; // Retourne une valeur par défaut si l'entrée est null ou undefined
    }
    return number.toLocaleString(); // Continue avec la conversion si la valeur est valide
  };

  const handleEdit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setCurrentFormData(record);
    setIsEditing(true);
    setEditingRecord(record);
    handleActeChange(record.codeacte);
    // Recalculez l'écart basé sur la valeur actuelle de montantBon et freel de l'enregistrement
    const freelValue = montantBon - totales.freelTotal; // Assurez-vous que freel a une valeur par défaut de 0 s'il est undefined
    const newEcart = freelValue;
    setEcart(newEcart);
  };

  const fetchDetailsData = async (numdoc) => {
    try {
      const data = await traitementFactureService.getDetailsByNumDoc(numdoc);
      setDetailsData(data.actes); // Suppose que data.actes contient les actes
      return data.actes;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données de détail :",
        error
      );
      return [];
    }
  };
  const showDetailsModal = async (record) => {
    setIsDetailModalVisible(true);
    setSelectedRecord(record);
    const details = await fetchDetailsData(record.numdoc);
    setDetailsData(details); // Mettre à jour `detailsData` avec les actes récupérés
  };

  useEffect(() => {
    if (isDetailModalOpen) {
      form.setFieldsValue({
        codeacte: null, // Réinitialiser ou définir la valeur par défaut du champ 'acte'
        libacte: null,
      });
    }
  }, [isDetailModalOpen, modalData, form]);

  const handleMontantBonChange = (value) => {
    setMontantBon(value);
    // Si une valeur est saisie, activer le sélecteur d'acte, sinon le désactiver
    setIsActeSelectable(!!value);
    setIsFieldsEnabledFreel(!!value);
    // Désactive les autres champs si montantBon est vidé ou non défini
    if (!value) setIsFieldsEnabled(false);
  };
  const handleMontantVerseChange = (value) => {
    setMontVerse(value);
  };

  useEffect(() => {
    form.setFieldsValue({
      qpmut: tauxpcData.qpmut,
      ticket: tauxpcData.ticket,
      qpassur: tauxpcData.qpassur,
      fexclus: tauxpcData.fexclus,
      ajustmt: tauxpcData.ajustmt,
      // qte: tauxpcData.qte,
    });
  }, [tauxpcData, form]);

  const handleActeChange = async (selectedActe) => {
    setActeSelected(selectedActe);

    setLoadingActes(true);
    const selectedActeDetails = modalData.lignePrestations.find(
      (prestation) => prestation.codeacte === selectedActe
    );
    const fullName = `${selectedActeDetails.codeacte} - ${selectedActeDetails.libacte}`;
    // Si l'acte est trouvé, utilisez ses détails pour construire l'objet acte

    setIsExclus(selectedActeDetails.exclus);
    setIsTarifJour(!!selectedActeDetails.tarif_jour);

    if (selectedActeDetails.tarif_jour) {
      form.setFieldsValue({
        freel: 0,
      });
    }

    if (!selectedActeDetails) {
      console.error("Acte sélectionné non trouvé.");
      return; // Ou gère l'erreur comme il convient
    }
    const qte = form.getFieldValue("qte");
    const acte = {
      ...selectedActeDetails,
      qte,
      fullName,
    };
    setIsTarifJour(!!selectedActeDetails.tarif_jour); // met à jour l’état

    let exclusValue = form.getFieldValue("fexclus");
    if (selectedActeDetails.exclus) {
      exclusValue = form.getFieldValue("freel");
      form.setFieldsValue({ fexclus: exclusValue });
    }

    try {
      const newPrestation = {
        ...detailData,
        qpmut: form.getFieldValue("qpmut"),
        ticket: form.getFieldValue("ticket"),
        qpassur: form.getFieldValue("qpassur"),
        fexclus: form.getFieldValue("fexclus"),
        ajustmt: form.getFieldValue("ajustmt"),
        exclus: selectedActeDetails.exclus,
        natprest: selectedActeDetails.codeprest,
        montdoc: form.getFieldValue("freel"),
        montverse: form.getFieldValue("ticket"),
        codefourn: record.numfourn,
        actes: [acte],
      };

      const tauxPCData = await prestationService.addTauxPC(newPrestation);
      // Mettez à jour l'état avec les données reçues ou effectuez d'autres actions nécessaires
      console.log("Taux PC reçu:", tauxPCData);
      setTauxpcData(tauxPCData);
      setIsFieldsEnabled(true);
    } catch (error) {
      console.error("Erreur lors de la récupération du taux PC:", error);
      // Gérez l'erreur comme nécessaire
    } finally {
      setLoadingActes(false);
    }
  };

  const handleFieldChange = async (changedValues, allValues) => {
    const { freel, qpassur, tarif_jour, fexclus, ajustmt, qte, codeacte } = allValues;
    const changedField = Object.keys(changedValues)[0];

    if (!codeacte || !modalData?.lignePrestations) {
      console.error("codeacte ou lignePrestations est manquant(e).");
      return;
    }

    const selectedActeDetails = modalData.lignePrestations.find(
      (prestation) => prestation.codeacte === codeacte
    );

    if (!selectedActeDetails) {
      console.error("Acte sélectionné non trouvé.");
      return;
    }

    const isExclus = selectedActeDetails.exclus;
    const isTarifJour = selectedActeDetails.tarif_jour === true;
    setIsTarifJour(isTarifJour); // garde l’état à jour
    const fullName = `${selectedActeDetails.codeacte} - ${selectedActeDetails.libacte}`;

    const acte = {
      ...selectedActeDetails,
      qte,
      fullName,
    };

    // Construction de base de newPrestation (sera réutilisé)
    const buildPrestationPayload = (freelValue, qteValue) => ({
      ...detailData,
      ajust: ajustmt,
      qpmut: form.getFieldValue("qpmut"),
      ticket: form.getFieldValue("ticket"),
      qpassur,
      fexclus,
      ajustmt,
      qte: qteValue,
      freel: freelValue,
      montdoc: freelValue,
      montverse: form.getFieldValue("ticket"),
      natprest: selectedActeDetails.codeprest,
      actes: [acte],
      exclus: isExclus,
      codefourn: record.numfourn,
    });

    //  Cas particulier : changement de la qte avec tarif_jour
    if ((changedField === "qte" || changedField === "tarif_jour") && isTarifJour) {
      const tarifJourValue = allValues.tarif_jour;
      const qteValue = allValues.qte;
      const freelXQte = tarifJourValue * qteValue;

      try {
        //const freelXQte = tarif_jour * qte;
        const payload = buildPrestationPayload(freelXQte, qte);
        const tauxPCData = await prestationService.addTauxPC(payload);
        setTauxpcData(tauxPCData);
        form.setFieldsValue({
          freel: freelXQte,
          qte: qteValue,
          qpmut: tauxPCData.qpmut,
          ticket: tauxPCData.ticket,
          qpassur: tauxPCData.qpassur,
        });
      } catch (error) {
        console.error("Erreur lors du recalcul Taux PC (Tarif Jour):", error);
      }
      return;
    }

    //  Validation : exclus mais pas de fexclus
    if (isExclus && (!fexclus || fexclus === 0)) {
      Modal.error({
        title: "Erreur",
        content: "Saisir le montant des frais exclus.",
      });
      return;
    }

    //  Cas normal (changement de champ hors qte/tarif_jour)
    try {
      const payload = buildPrestationPayload(freel, qte);
      const tauxPCData = await prestationService.addTauxPC(payload);
      setTauxpcData(tauxPCData);
      form.setFieldsValue({
        qpmut: tauxPCData.qpmut,
        ticket: tauxPCData.ticket,
        qpassur: tauxPCData.qpassur,
      });
    } catch (error) {
      console.error("Erreur lors de la récupération du taux PC:", error);
    }
  };

  const handleBlur = (fieldName) => {
    const allValues = form.getFieldsValue();

    // Trouver l'acte sélectionné pour obtenir la valeur de exclus
    const selectedActeDetails = modalData.lignePrestations.find(
      (prestation) => prestation.codeacte === allValues.codeacte
    );

    if (
      selectedActeDetails &&
      selectedActeDetails.exclus &&
      fieldName === "freel"
    ) {
      // Si l'acte est exclus et que le champ flou est freel, patcher fexclus avec freel
      const freelValue = allValues.freel;
      form.setFieldsValue({ fexclus: freelValue });
      allValues.fexclus = freelValue;

    }

    handleFieldChange({ [fieldName]: allValues[fieldName] }, allValues);
  };

  useEffect(() => {
    const newTotals = tableData1.reduce(
      (acc, row) => ({
        qteTotal: acc.qteTotal + Number(row.qte || 0),
        freelTotal: acc.freelTotal + Number(row.freel || 0),
        qpmutTotal: acc.qpmutTotal + Number(row.qpmut || 0),
        ticketTotal: acc.ticketTotal + Number(row.ticket || 0),
        qpassurTotal: acc.qpassurTotal + Number(row.qpassur || 0),
        fexclusTotal: acc.fexclusTotal + Number(row.fexclus || 0),
        ajustmtTotal: acc.ajustmtTotal + Number(row.ajustmt || 0),
      }),
      {
        qteTotal: 0,
        freelTotal: 0,
        qpmutTotal: 0,
        ticketTotal: 0,
        qpassurTotal: 0,
        fexclusTotal: 0,
        ajustmtTotal: 0,
      }
    );

    setTotals(newTotals);
  }, [tableData1]);

  // Affichage des totaux dans le résumé de la table
  const renderSummary = () => (
    <Table.Summary.Row>
      <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
      <Table.Summary.Cell index={1}></Table.Summary.Cell>
      <Table.Summary.Cell index={2} align="center">
        {formatNumberWithSeparator(totales.qteTotal)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={3} align="right">
        {formatNumberWithSeparator(totales.freelTotal)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={4} align="right">
        {formatNumberWithSeparator(totales.qpmutTotal)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={5} align="right">
        {formatNumberWithSeparator(totales.ticketTotal)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={6} align="right">
        {formatNumberWithSeparator(totales.qpassurTotal)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={7} align="right">
        {formatNumberWithSeparator(totales.fexclusTotal)}
      </Table.Summary.Cell>
      <Table.Summary.Cell index={8} align="right">
        {formatNumberWithSeparator(totales.ajustmtTotal)}
      </Table.Summary.Cell>
    </Table.Summary.Row>
  );
  const renderSummary2 = (pageData) => {
    // Calcul des totaux pour les données actuellement affichées (ou pour tout le tableau, selon votre besoin)
    const totals = secondTableData.reduce(
      (acc, row) => {
        acc.totalMontdoc += Number(row.montdoc || 0);
        acc.totalQpmut += Number(row.qpmut || 0);
        acc.totalTicket += Number(row.ticket || 0);
        acc.totalQpAssur += Number(row.qpassur || 0);
        acc.totalMontVerse += Number(row.montverse || 0);
        acc.totalFexclus += Number(row.fexclus || 0);

        return acc;
      },
      {
        totalMontdoc: 0,
        totalQpmut: 0,
        totalTicket: 0,
        totalQpAssur: 0,
        totalMontVerse: 0,
        totalFexclus: 0,
      }
    );

    return (
      <>
        <Table.Summary.Row>
          <Table.Summary.Cell>Total</Table.Summary.Cell>
          <Table.Summary.Cell></Table.Summary.Cell>
          <Table.Summary.Cell></Table.Summary.Cell>
          <Table.Summary.Cell></Table.Summary.Cell>
          <Table.Summary.Cell></Table.Summary.Cell>
          <Table.Summary.Cell></Table.Summary.Cell>
          <Table.Summary.Cell></Table.Summary.Cell>
          <Table.Summary.Cell textAlign="right">
            {formatNumberWithSeparator(totals.totalMontdoc)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {formatNumberWithSeparator(totals.totalQpmut)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {formatNumberWithSeparator(totals.totalTicket)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {formatNumberWithSeparator(totals.totalQpAssur)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {formatNumberWithSeparator(totals.totalMontVerse)}
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            {formatNumberWithSeparator(totals.totalFexclus)}
          </Table.Summary.Cell>
        </Table.Summary.Row>
      </>
    );
  };
  // const totalFexclus = secondTableData

  const handleDelete = (key) => {
    const newData = tableData1.filter((item) => item.key !== key);
    setTableData1(newData);
  };

  const handleDeleteLine = async (numdoc) => {
    try {
      await traitementFactureService.deleteLine(numdoc);
      message.success("La ligne a été supprimée avec succès.");
      // Mettez à jour les données de la table après la suppression
      const newData = tableData.filter((item) => item.numdoc !== numdoc);
      setTableData(newData);
    } catch (error) {
      message.error("Erreur lors de la suppression de la ligne.");
    }
  };

  const handleAddToTableData1 = async () => {
    const formData = form.getFieldsValue();
    const ticketValue = formData.ticket;

    // Mettre montverse à jour uniquement ici, après validation
    setMontVerse(ticketValue);

    const selectedActeDetail = modalData.lignePrestations.find(
      (prestation) => prestation.codeacte === formData.codeacte
    );
    const libacte = selectedActeDetail
      ? selectedActeDetail.libacte
      : "Libellé inconnu";

    if (formData.freel > montantBon) {
      Modal.error({
        title: "Erreur",
        content: "Le montant freel est supérieur au montant bon.",
      });
      return;
    }

    if (selectedActeDetail.exclus && !formData.fexclus) {
      Modal.warning({
        title: "Alert",
        content: "Saisir le montant des frais exclus.",
      });
      return;
    }

    try {
      const tauxPCResponse = await prestationService.addTauxPC({
        ...detailData,
        montdoc: formData.freel,
        fexclus: formData.fexclus,
        ajust: formData.ajustmt,
        dateacte: formData.dateacte,
        ajustmt: formData.ajustmt,
        qte: formData.qte,
        actes: [selectedActeDetail],
      });

      form.setFieldsValue({
        qpmut: tauxPCResponse.qpmut,
        ticket: tauxPCResponse.ticket,
        qpassur: tauxPCResponse.qpassur,
      });

      const updatedData = {
        key: formData.codeacte,
        libacte,
        codeprest: selectedActeDetail.codeprest,
        ...formData,
        qpmut: tauxPCResponse.qpmut,
        ticket: tauxPCResponse.ticket,
        qpassur: tauxPCResponse.qpassur,
      };

      if (isEditing) {
        setTableData1((prevData) =>
          prevData.map((item) =>
            item.codeacte === editingRecord.codeacte ? updatedData : item
          )
        );
        setIsEditing(false);
        setEditingRecord(null);
      } else {
        const acteExisteDeja = tableData1.some(
          (row) => row.codeacte === formData.codeacte
        );
        if (acteExisteDeja) {
          Modal.error({
            title: "Erreur",
            content: "Cet acte a déjà été ajouté.",
          });
          return;
        }

        setTableData1((prevData) => [...prevData, updatedData]);
      }

      // Réinitialiser les champs sauf freel
      form.resetFields([
        "codeacte",
        "qpmut",
        "ticket",
        "qpassur",
        "fexclus",
        "ajustmt",
        "qte",
      ]);
      form.setFieldsValue({ freel: ecart });
      setIsFieldsEnabled(false);
      setIsExclus(false);
      setIsFormValid(false);
    } catch (error) {
      Modal.error({
        title: "Erreur de calcul",
        content: "Impossible de recalculer les valeurs. Veuillez réessayer.",
      });
    }
  };

  const handleImportModalOpen = () => {
    setIsImportModalOpen(true);
  };

  const fileInputRef = useRef(null);

  const handleImportModalClose = () => {
    setIsImportModalOpen(false);
    setImportedData([]);
    setTotales({ totalLines: 0, totalCalculated: 0 });

    // Réinitialise l'input file
    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Réinitialisation
    }
  };

  const handleFileImport = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: "binary" });
      const sheetName = workbook.SheetNames[0];
      const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

      // Calcul des totaux
      const totalCalculated = sheetData.reduce(
        (sum, row) => sum + (row.Montant || 0),
        0
      );
      setTotales({ totalLines: sheetData.length, totalCalculated });
      setImportedData(sheetData);
    };
    reader.readAsBinaryString(file);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleFileImport(file);
    } else {
      message.error("Veuillez sélectionner un fichier Excel.");
    }
  };

  const handleImportSubmit = async () => {
    if (!record || !record.numfourn || !record.numenreg) {
      message.error("Informations manquantes : codefourn ou numFact absent.");
      return;
    }

    const formattedData = importedData.map((item) => ({
      codefourn: record.numfourn,
      numFact: record.numenreg,
      numdoc: item.NumDoc, // Conversion des champs
      ref_medoc: item.Ref_Medoc,
      libacte: item.Libelle,
      nb_article: item.NB_article,
      montant: item.Montant,
      qpmut: item.qpmut,
      qte: item.NB_article, // Hypothèse : NB_article est la quantité
      numligne_acte: item.Ref_Medoc, // Hypothèse : numligne_acte = Ref_Medoc
      freel: item.Montant, // Même que Montant si Freel = Montant
      numfact: record.numFact, // Ajouté pour s'assurer que numfact est cohérent
    }));

    const payload = {
      codefourn: record.numfourn,
      numFact: record.numenreg,
      listMedoc: formattedData,
    };
    Modal.confirm({
      title: "Confirmer l'importation",
      content: "Êtes-vous sûr de vouloir soumettre ces données ?",
      okText: "Oui",
      cancelText: "Non",
      onOk: async () => {
        try {
          const response = await traitementFactureService.ImportBonFile(
            payload
          );

          if (response.Import === "ErrorBons") {
            showErrorBonsModal(); // Affiche le modal en cas d'erreur
          } else if (response.Import === "ErrorActes") {
            showErrorActesModal(); // Affiche le modal en cas d'erreur
          } else if (response.Import === "BonsTraites") {
            showErrorBonsTraitesModal(); // Affiche le modal en cas d'erreur
          } else {
            message.success("Les bons ont été importés avec succès !");
            handleImportModalClose();
            loadDataFourn();
            loadData();
          }
          console.log("Réponse de l'API :", response);
        } catch (error) {
          console.error("Erreur lors de l'importation :", error);
          message.error("Erreur lors de l'importation des bons.");
        }
      },
      onCancel: () => {
        message.info("Importation annulée.");
      },
    });
  };

  // Fonction pour afficher le modal d'erreur
  const showErrorBonsModal = () => {
    Modal.error({
      title: "Bons inexistants",
      icon: <ExclamationCircleOutlined />,
      content:
        "Un ou plusieurs bons ont été mal saisis. Veuillez voir la liste en cliquant sur OK.",
      okText: "OK",
      onOk: async () => {
        try {
          // Appel à errorBon qui gère le téléchargement
          await traitementFactureService.errorBon();
          message.success("Fichier des bons erronés téléchargé avec succès.");
        } catch (error) {
          console.error("Erreur lors de l'export des bons erronés :", error);
          message.error(
            "Erreur lors du téléchargement du fichier des bons erronés."
          );
        }
      },
    });
  };
  const showErrorActesModal = () => {
    Modal.error({
      title: "Medicaments inexistants",
      icon: <ExclamationCircleOutlined />,
      content:
        "Un ou plusieurs medicaments n'existent pas dans la base des actes.. Veuillez voir la liste en cliquant sur OK.",
      okText: "OK",
      onOk: async () => {
        try {
          // Appel à errorBon qui gère le téléchargement
          await traitementFactureService.errorActes();
          message.success("Fichier des actes erronés téléchargé avec succès.");
        } catch (error) {
          console.error("Erreur lors de l'export des bons erronés :", error);
          message.error(
            "Erreur lors du téléchargement du fichier des bons erronés."
          );
        }
      },
    });
  };

  const showErrorBonsTraitesModal = () => {
    Modal.error({
      title: "Importation Bons",
      icon: <CloseCircleOutlined />,
      content: "Bons déjà traités.",
      okText: "OK",
      onOk: async () => {
        try {
          // Appel à errorBon qui gère le téléchargement
          await traitementFactureService.errorBonsTraites();
          message.success("Fichier des actes erronés téléchargé avec succès.");
        } catch (error) {
          console.error("Erreur lors de l'export des bons erronés :", error);
          message.error(
            "Erreur lors du téléchargement du fichier des bons erronés."
          );
        }
      },
    });
  };

  const onFinish = async () => {
    if (ecart !== 0) {
      Modal.error({
        title: "Erreur",
        content: "Le montant de l'écart n'est pas à 0.",
      });
      return;
    }

    if (!numfourn) {
      Modal.error({
        title: "Erreur",
        content: "Le numéro de fournisseur est manquant.",
      });
      return;
    }

    const newPrestation = {
      ...detailData,
      actes: tableData1.map((item) => ({
        qte: item.qte,
        ajustmt: item.ajustmt,
        fexclus: item.fexclus,
        numdoc: detailData.numdoc,
        numligne_acte: item.codeacte,
        codeprest: item.codeprest,
        freel: item.freel,
        qpassur: item.qpassur,
        qpmut: item.qpmut,
        tarifj: item.freel,
        ticket: item.ticket,
        // codefourn: item.codefourn === "99999" ? numfourn : item.codefourn, // Vérification et remplacement ici
      })),
      codefourn:
        detailData.codefourn === "99999" ? numfourn : detailData.codefourn,
      numfact: numenreg,
      montdoc: totales.freelTotal,
      montverse: /* totales.ticketTotal */ montverse,
      qpmut: totales.qpmutTotal,
      qpassur: totales.qpassurTotal,
      ticket: totales.ticketTotal,
    };

    console.log("newPrestation avant envoi:", newPrestation);

    try {
      const response = await prestationService.AddLignePrestation(
        newPrestation
      );
      message.success("Prestation ajoutée avec succès");
      await loadData();
      await loadDataFourn();

      setDetailData({});

      setIsExclus(false);
      setSelectedNumDoc(null);
      setMontantBon(0);
      setTableData1([]);
      form.resetFields();
    } catch (error) {
      console.error("Erreur lors de l'ajout de la prestation:", error);
    }
  };

  useEffect(() => {
    const updatedTotalMontdoc = secondTableData.reduce(
      (total, item) => total + Number(item.montdoc),
      0
    );
    const updatedNombreDeLignes = secondTableData.length;
    const updatedEcartsecond = modalData?.freelValue
      ? modalData.freelValue - updatedTotalMontdoc
      : 0;

    setModalData((prevData) => ({
      ...prevData,
      totalMontdoc: updatedTotalMontdoc,
      nombreDeLignes: updatedNombreDeLignes,
      ecartsecond: updatedEcartsecond,
    }));
  }, [secondTableData, modalData?.freelValue]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setEditDate(false);
    setDateModified(true); // Indique que l'utilisateur a modifié la date
  };

  useEffect(() => {
    // Assurez-vous que la date de début est correctement formatée et valide.
    // Si paramsDetails.datedeb est une chaîne, vous devez peut-être spécifier le format.
    if (paramsDetails && paramsDetails.datedeb) {
      // Exemple si vous savez que la date vient dans un format spécifique, disons 'YYYY-MM-DD'
      setSelectedDate(dayjs(paramsDetails.datedeb, "YYYY-MM-DD"));
    } else {
      setSelectedDate(dayjs()); // Fallback à la date actuelle si non disponible
    }
  }, [paramsDetails]);
  useEffect(() => {
    // Met à jour 'freel' chaque fois que 'montantBon' change
    form.setFieldsValue({ freel: ecart });

    // Optionnellement, réinitialiser les valeurs si aucun acte n'est sélectionné
    form.resetFields([
      "qpassur",
      "qpmut",
      "ticket",
      "fexclus",
      "ajustmt",
      "qte",
    ]);
    //setIsFieldsEnabled(true)
  }, [ecart, form]);

  useEffect(() => {
    if (acteSelected) {
      form.setFieldsValue({
        qpassur: tauxpcData.qpassur,
        fexclus: tauxpcData.fexclus,
        ajustmt: tauxpcData.ajustmt,
        // qte: tauxpcData.qte,
      });
    } else {
      // Optionnellement, réinitialiser les valeurs si aucun acte n'est sélectionné
      form.resetFields([
        "qpassur",
        "fexclus",
        "qpmut",
        "ticket",
        "ajustmt",
        "qte",
      ]);
    }
  }, [acteSelected, form, tauxpcData.qpassur, tauxpcData.fexclus, tauxpcData.ajustmt]);

  const recalculateEcart = useCallback(() => {
    const totalFreel = tableData1.reduce((acc, row) => acc + row.freel, 0);
    setEcart(montantBon - totalFreel);
  }, [tableData1, montantBon]);

  useEffect(() => {
    recalculateEcart();
  }, [tableData1, montantBon, recalculateEcart]);

  useEffect(() => {
    const newTotal = secondTableData.reduce(
      (total, item) => total + Number(item.montdoc),
      0
    );
    setTotalMontdoc(newTotal);
  }, [secondTableData]);

  const showModal = (record = null) => {
    if (record) {
      // console.log("Enregistrement en cours d'édition :", record);
      setEditingRecord(record);
      setIsEditing(true);
    } else {
      setEditingRecord(null);
      setIsEditing(false);
    }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setEditingRecord(null);
    setIsEditing(false);
  };
  const handleSuccess = async () => {
    await loadData();
    await loadDataFourn();
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
    selections: [
      {
        key: "select-all",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CheckSquareOutlined style={{ color: "#52c41a" }} />
            Sélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          const allKeys = filteredSecondTableData.map((item) => item.numdoc);
          setSelectedRowKeys(allKeys);
        },
      },
      {
        key: "clear-selection",
        text: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <CloseSquareOutlined style={{ color: "#ff4d4f" }} />
            Désélectionner toutes les lignes
          </span>
        ),
        onSelect: () => {
          setSelectedRowKeys([]);
        },
      },
    ],
    getCheckboxProps: (record) => ({
      name: record.numdoc,
    }),
  };

  const userId = localStorage.getItem("login");

  const handleValidFacture = async () => {
    try {
      const payload = {
        ...record,
        etat:
          ecartSecondTable === 0
            ? "T"
            : ecartSecondTable === freelValue
              ? "R"
              : "S",
        datetrait: selectedDate.format("YYYY-MM-DD"),
        date_process: moment().format("YYYY-MM-DD"),
      };
      const data = await traitementFactureService.updateListTraitementFact(
        record.numenreg,
        payload
      );
      console.log("Mise à jour réussie :", data);
      message.success("La facture a été validée avec succès.");
    } catch (error) {
      console.error("Erreur lors de la validation de la facture :", error);
      message.error("Erreur lors de la validation de la facture.");
    }
  };

  /*  const handleValidFacture = async () => {
    try {
      const etatValue =
      ecartSecondTable === 0
        ? "T"
        : ecartSecondTable !== freelValue
        ? "S"
        : "R";

    const payload = {
      ...record,
      etat: etatValue,
      datetrait: selectedDate.format("YYYY-MM-DD"),
      date_process: moment().format("YYYY-MM-DD"),
    };
      const data = await traitementFactureService.updateListTraitementFact(
        record.numenreg,
        payload
      );
      console.log("Mise à jour réussie :", data);
      message.success("La facture a été validée avec succès.");
    } catch (error) {
      console.error("Erreur lors de la validation de la facture :", error);
      message.error("Erreur lors de la validation de la facture.");
    }
  };
 */

  const showConfirm = () => {
    Modal.confirm({
      title: "Confirmez-vous la validation de cette facture?",
      async onOk() {
        try {
          await handleValidFacture(); // Valide la facture en premier
          navigate("/factures"); // Navigue vers la page /factures après la validation
        } catch (error) {
          console.error("Erreur lors de la validation:", error);
        }
      },
      onCancel() {
        console.log("Annulation de la validation de la facture");
      },
    });
  };
  const getBackgroundColor = (etat) => {
    switch (etat) {
      case "R":
        return "#f39c12"; // Couleur pour "En cours de traitement"
      case "T":
        return "green"; // Couleur pour "Traitée"
      case "S":
        return "orange"; // Couleur pour "Traitée"
      default:
        return "red"; // Couleur par défaut pour "Inconnu"
    }
  };
  const getTextColor = (etat) => {
    switch (etat) {
      case "R":
        return "black"; // Couleur du texte pour "En cours de traitement"
      case "T":
        return "white"; // Couleur du texte pour "Traitée"
      default:
        return "black"; // Couleur par défaut pour "Inconnu"
    }
  };

  const handleExport = () => {
    // Ici, rowSelection.selectedRowKeys contient les clés des lignes sélectionnées
    const selectedData = secondTableData.filter((item) =>
      selectedRowKeys.includes(item.numdoc)
    );

    if (selectedData.length === 0) {
      message.warning("Aucune ligne sélectionnée pour l'exportation.");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(selectedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "tableau_bon_traité.xlsx");
  };

  const handleExportDetails = async () => {
    let allSelectedDetails = [];

    for (const numdoc of selectedRowKeys) {
      const details = await fetchDetailsData(numdoc);
      allSelectedDetails = [...allSelectedDetails, ...details];
    }

    // Utilisation de XLSX pour l'export
    const ws = XLSX.utils.json_to_sheet(allSelectedDetails);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Détails Bon");
    XLSX.writeFile(wb, "details_bon.xlsx");
  };

  useEffect(() => {
    setIsSaveButtonEnabled(ecart === 0 && tableData1.length > 0);
  }, [ecart, tableData1]);

  useEffect(() => {
    setFilteredData(tableData); // Initialiser filteredData avec tableData au chargement
  }, [tableData]);

  useEffect(() => {
    setFilteredSecondTableData(secondTableData); // Initialiser filteredData avec tableData au chargement
  }, [secondTableData]);

  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour filteredData sans modifier tableData
  };

  const handleSearch1 = (value) => {
    setSearchSecondTableValue(value);
    const filtered = secondTableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredSecondTableData(filtered); // Met à jour les données filtrées
  };

  useEffect(() => {
    if (detailData.datedoc) {
      form.setFieldsValue({
        dateacte: dayjs(detailData.datedoc, "YYYY-MM-DD"), // Met à jour 'dateacte' avec 'datedoc'
      });
    }
  }, [detailData, form]);

  return (
    <div>
      <Card>
        <Row gutter={16} style={{ marginBottom: "18px" }}>
          <Col span={8}>
            {paramsDetails && record && (
              <List size="small" bordered>
                <List.Item
                  style={{
                    display: "flex",
                    background: getBackgroundColor(record.etat),
                  }}
                >
                  <div style={{ color: getTextColor(record.etat) }}>
                    <strong>Fact. N° {record.numenreg} / </strong>
                    <br />
                    <strong>
                      {record.numfourn} - {record.raisoc}
                    </strong>
                  </div>
                </List.Item>
                <List.Item
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <strong>Date:</strong>
                  <strong>
                    {dayjs(record.datefact).format("D MMMM YYYY")}
                  </strong>
                </List.Item>
                <List.Item
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <strong>Mois Comptable:</strong>
                  <strong>
                    {editDate ? (
                      <DatePicker
                        value={selectedDate}
                        disabledDate={(current) =>
                          current && current > dayjs().endOf("day")
                        }
                        format="DD/MM/YYYY"
                        autoFocus
                        onOpenChange={(open) => {
                          if (!open) setEditDate(false);
                        }} // Fermer l'édition seulement quand le calendrier se ferme
                        onChange={handleDateChange}
                      />
                    ) : (
                      <>
                        <span>
                          {selectedDate
                            ? selectedDate.format("MMM-YYYY")
                            : "Date inconnue"}
                        </span>
                        <Button
                          type="text"
                          icon={<EditOutlined />}
                          onClick={() => setEditDate(true)}
                        />
                      </>
                    )}
                  </strong>
                </List.Item>

                <List.Item
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <strong>Etat</strong>
                  <strong>
                    {record.etat === "R" ? (
                      <Tag style={{ background: "#f39c12", color: "black" }}>
                        En cours de traitement
                      </Tag>
                    ) : record.etat === "T" ? (
                      <Tag style={{ background: "green", color: "white" }}>
                        Traitée
                      </Tag>
                    ) : record.etat === "S" ? (
                      <Tag style={{ background: "orange", color: "white" }}>
                        Écart détecté
                      </Tag>
                    ) : (
                      <Tag color="red">Inconnu</Tag>
                    )}
                  </strong>
                </List.Item>

                <List.Item
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <strong>Frais Réel:</strong>
                  <strong>{formatNumberWithSeparator(record.freel)}CFA</strong>
                </List.Item>
                <List.Item
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <strong>Remise:</strong>
                  <strong>{record.remise} CFA</strong>
                </List.Item>
                <List.Item
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <strong>Montant Net Facture:</strong>
                  <strong style={{ color: "green" }}>
                    {formatNumberWithSeparator(record.montfact)} CFA
                  </strong>
                </List.Item>
              </List>
            )}
          </Col>
          <Col span={16}>
            <Space wrap style={{ marginBottom: "18px" }}>
              <Button
                icon={<PlusCircleOutlined />}
                className="buttonRecep"
                onClick={() => showModal()}
              >
                Créer Bon Manuel
              </Button>
              <ModalBM
                isOpen={isModalOpen}
                onClose={closeModal}
                onSuccess={handleSuccess}
                numfourn={record?.numfourn}
                codespe={record?.codespe}
                editingRecord={editingRecord}
                isEditing={isEditing}
              />

              <Button
                icon={<ImportOutlined />}
                className="buttonCompta"
                onClick={handleImportModalOpen}
              >
                Importer Bon Pharma
              </Button>
              <Button
                icon={<CheckCircleOutlined />}
                disabled={ecartSecondTable !== 0}
                onClick={showConfirm}
                className="buttonExport"
              >
                Valider Facture
              </Button>

              <Link to={"/factures"}>
                <Button
                  icon={<CloseCircleOutlined />}
                  className="buttonClose"
                  style={{ marginRight: 5 }}
                >
                  Fermer
                </Button>
              </Link>

              <Input
                placeholder="Rechercher..."
                bordered={false}
                style={{ borderBottom: "1px solid #000" }}
                onChange={(e) => handleSearch(e.target.value)}
                onPressEnter={(e) => handleSearch(e.target.value)}
              />

            </Space>
            <Table
              scroll={{
                x: true,
              }}
              style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
              className="custom-header1-table"
              bordered
              dataSource={filteredData}
              loading={loadingTable2}
              columns={[
                {
                  title: "N° Bon/Lettre",
                  dataIndex: "numdoc",
                  key: "numdoc",
                  align: "center",
                  sorter: (a, b) => a.numdoc.localeCompare(b.numdoc),
                },
                {
                  title: "Date",
                  dataIndex: "datedoc",
                  key: "datedoc",
                  align: "center",
                  sorter: (a, b) =>
                    moment(a.datedoc).unix() - moment(b.datedoc).unix(),
                  render: (text, record) => (
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        textAlign: "center",
                        paddingLeft: "5px",
                        paddingRight: "5px",
                      }}
                    >
                      {moment(text).locale("fr").format("DD/MM/YYYY")}{" "}
                    </div>
                  ),
                },
                {
                  title: "Mat. Part.",
                  dataIndex: "matripart",
                  key: "matripart",
                  align: "center",
                  // sorter: (a, b) => a.matripart.localeCompare(b.matripart),
                },
                {
                  title: "Participant",
                  dataIndex: "participant",
                  key: "participant",
                  // sorter: (a, b) => a.participant.localeCompare(b.participant),
                },
                {
                  title: "Type Benef.",
                  dataIndex: "typebenef",
                  key: "typebenef",
                  align: "center",
                  // sorter: (a, b) => a.typebenef.localeCompare(b.typebenef),
                },
                {
                  title: "Beneficiaire",
                  dataIndex: "beneficiaire",
                  key: "beneficiaire",
                  // sorter: (a, b) =>
                  //   a.beneficiaire.localeCompare(b.beneficiaire),
                },
                {
                  title: (
                    <div
                      style={{
                        backgroundColor: "#010f1c",
                        color: "white",
                        padding: "1px",
                      }}
                    ></div>
                  ),
                  dataIndex: "actions",
                  key: "actions",
                  align: "center",
                  fixed: "right",
                  render: (text, record) => (
                    <span>
                      <Tooltip title="Traiter">
                        <EyeOutlined
                          style={{
                            cursor: "pointer",
                            color: "green",
                            marginRight: 8,
                          }}
                          onClick={() => showModalWithData(record)}
                        />
                      </Tooltip>
                      {record.naturedoc === "Manuel" && (
                        <>
                          <Tooltip title="Modifier">
                            <EditOutlined
                              style={{
                                cursor: "pointer",
                                color: "orange",
                                marginRight: 8,
                              }}
                              onClick={() => showModal(record)}
                            />
                          </Tooltip>

                          <Popconfirm
                            title="Êtes-vous sûr de vouloir supprimer ?"
                            okText="Oui"
                            cancelText="Non"
                            onConfirm={() => handleDeleteLine(record.numdoc)}
                          >
                            <Tooltip title="Supprimer">
                              <DeleteFilled
                                style={{
                                  cursor: "pointer",
                                  color: "red",
                                }}
                              />
                            </Tooltip>
                          </Popconfirm>
                        </>
                      )}
                    </span>
                  ),
                },
              ]}
              pagination={{
                pageSize: 5, // le nombre d'éléments par page
              }}
            />
          </Col>

          <DraggableModal
            title={`Traitement Bon N° ${detailData.numdoc ? detailData.numdoc : ""
              } / Facture N° ${record.numenreg} / ${record.numfourn} - ${record.raisoc
              }`}
            open={isDetailModalOpen}
            maskClosable={false}
            onCancel={() => setIsDetailModalOpen(false)}
            style={{ top: 20 }}
            width={1000}
            footer={[
              <Button
                className="buttonClose"
                key="back"
                onClick={() => {
                  form.resetFields();
                  form.resetFields([
                    "codeacte",
                    "qpmut",
                    "ticket",
                    "qpassur",
                    "fexclus",
                    "ajustmt",
                    "qte",
                  ]);
                  setIsDetailModalOpen(false);
                  setIsFieldsEnabled(false);
                  setIsFormValid(false);
                  setIsActeSelectable(false);
                  setTableData1([]);
                  setIsExclus(false);
                  setIsTarifJour(false)
                }}
              >
                Fermer
              </Button>,
              <Button
                key="submit"
                type="primary"
                className="Buttonvalid"
                onClick={() => form.submit()}
                disabled={!isSaveButtonEnabled}
              >
                Enregistrer
              </Button>,
            ]}
          >
            <Form
              form={form}
              layout="vertical"
              onFinish={onFinish}
              size="small"
              onValuesChange={(changedValues, allValues) => {
                const { codeacte, freel, qte, qpmut, ticket } = allValues;
                setIsFormValid(
                  codeacte &&
                  qte > 0 &&
                  (!isTarifJour || allValues.tarif_jour > 0) &&
                  qpmut >= 0 &&
                  ticket >= 0
                );

              }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item label="Sélectionnez un Bon">
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      style={{ width: "100%", marginBottom: 20 }}
                      placeholder="Sélectionnez un Numéro de Bon"
                      onChange={handleNumDocChange}
                      value={selectedNumDoc}
                    >
                      {tableData.map((item) => (
                        <Select.Option key={item.numdoc} value={item.numdoc}>
                          {`${item.numdoc} - ${item.participant}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <div>
                    <div
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong>
                        Montant Net Facture:{" "}
                        {modalData?.freelValue
                          ? formatNumberWithSeparator(modalData.freelValue)
                          : "0"}{" "}
                        CFA
                      </strong>
                      <strong>
                        Total Bons traités :{" "}
                        {modalData?.totalMontdoc
                          ? formatNumberWithSeparator(modalData.totalMontdoc)
                          : "0"}{" "}
                        CFA
                      </strong>
                    </div>
                    <div
                      style={{
                        marginBottom: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong>
                        Nombre(s) de Bon :{" "}
                        {modalData?.nombreDeLignes
                          ? formatNumberWithSeparator(modalData.nombreDeLignes)
                          : "0"}
                      </strong>
                      <strong>
                        Ecart :{" "}
                        {modalData?.ecartsecond
                          ? formatNumberWithSeparator(modalData.ecartsecond)
                          : "0"}{" "}
                        CFA
                      </strong>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={12}>
                  <List size="small" bordered>
                    <List.Item
                      style={{ display: "flex", background: "darkgoldenrod" }}
                    >
                      <div>Entête Bon</div>
                    </List.Item>
                    <List.Item
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong>Date : </strong>
                      <strong>
                        {detailData.datedoc
                          ? moment(detailData.datedoc).format("DD/MM/YYYY")
                          : ""}
                      </strong>
                    </List.Item>
                    <List.Item
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong>Part. : </strong>
                      <strong>
                        {detailData.matripart || ""} -{" "}
                        {detailData.participant || ""}
                      </strong>
                    </List.Item>

                    <List.Item
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong>Bénéficiaire : </strong>
                      <strong>{detailData.beneficiaire || ""}</strong>
                    </List.Item>
                    <List.Item
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong>
                        Montant Bon ({formatNumberWithSeparator(montantBon)}):
                      </strong>

                      <InputNumber
                        className="right-align-input"
                        style={{ width: "50%" }}
                        value={montantBon}
                        onChange={handleMontantBonChange}
                      />
                    </List.Item>

                    {selectedticket && (
                      <List.Item
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <strong>
                          Montant Verse ({formatNumberWithSeparator(montverse)}
                          ):
                        </strong>

                        <InputNumber
                          className="right-align-input"
                          style={{ width: "50%" }}
                          value={montverse}
                          onChange={(value) => {
                            setMontVerse(value);
                          }}
                        />
                      </List.Item>
                    )}

                    <Divider />
                    <List.Item
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong>Ecart: </strong>
                      <strong style={{ color: "green" }}>
                        {formatNumberWithSeparator(ecart)}
                      </strong>
                    </List.Item>
                  </List>
                </Col>
                <Col span={12}>
                  <div>
                    <strong>Saisie des Actes</strong>
                  </div>
                  <Form.Item
                    label={
                      <>
                        Acte
                        {isExclus && (
                          <span style={{ color: "red" }}> (exclus)</span>
                        )}
                      </>
                    }
                    name="codeacte"
                  >
                    <Select
                      loading={loadingActes}
                      onChange={handleActeChange}
                      disabled={!isActeSelectable}
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {modalData?.lignePrestations?.map((lignePrestation) => (
                        <Select.Option
                          key={lignePrestation.codeacte}
                          value={lignePrestation.codeacte}
                        >
                          {`${lignePrestation.codeacte} ${lignePrestation.libacte}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                  {isTarifJour &&
                    <>
                      <Form.Item
                        label="Tarif Jour"
                        name="tarif_jour"
                        initialValue="0"
                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          disabled={!isFieldsEnabledFreel}
                          onBlur={() => handleBlur("tarif_jour")}
                        />
                      </Form.Item>

                    </>
                  }
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        label="Frais Réel"

                        name="freel"
                        initialValue="0"
                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          disabled={!isFieldsEnabledFreel}
                          onBlur={() => handleBlur("freel")}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="QP.IPM" name="qpmut" initialValue="0">
                        <InputNumber
                          readOnly
                          style={{ width: "100%" }}
                          disabled={!isFieldsEnabled}
                          onBlur={() => handleBlur("qpmut")}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="QP.PART" name="ticket" initialValue="0">
                        <InputNumber
                          style={{ width: "100%" }}
                          readOnly
                          disabled={!isFieldsEnabled}
                          onBlur={() => handleBlur("ticket")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item
                        label="QP. Mut / FS"
                        name="qpassur"
                        initialValue="0"
                      >
                        <InputNumber
                          readOnly
                          style={{ width: "100%" }}
                          disabled={!isFieldsEnabled}
                          onBlur={() => handleBlur("qpassur")}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Frais Exclus"
                        name="fexclus"
                        initialValue="0"
                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          disabled={!isFieldsEnabled}
                          onBlur={() => handleBlur("fexclus")}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Ajustement"
                        name="ajustmt"
                        initialValue="0"
                      >
                        <InputNumber
                          style={{ width: "100%" }}
                          disabled={!isFieldsEnabled}
                          onBlur={() => handleBlur("ajustmt")}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={8}>
                      <Form.Item label={isTarifJour ? "Nombre de Jours" : "Quantité"} name="qte" initialValue="1">
                        <InputNumber
                          style={{ width: "100%" }}
                          disabled={!isFieldsEnabled}
                          onBlur={() => handleBlur("qte")}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item label="Date Acte" name="dateacte">
                        <DatePicker
                          format="DD/MM/YYYY"
                          disabledDate={(current) => current && current > dayjs().endOf('day')}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item>
                    <div style={{ textAlign: "right" }}>
                      {isEditing ? (
                        <>
                          <Button
                            type="default"
                            onClick={() => {
                              setIsEditing(false);
                              setEditingRecord(null);
                              form.resetFields();
                              setIsTarifJour(false);
                            }}
                            style={{ marginRight: 8 }}
                          >
                            Annuler
                          </Button>
                          <Button
                            type="primary"
                            onClick={handleAddToTableData1}
                            disabled={
                              tauxpcData.qpmut <= 0 && tauxpcData.ticket <= 0
                            }
                          >
                            Modifier
                          </Button>
                        </>
                      ) : (
                        <Button
                          type="primary"
                          onClick={handleAddToTableData1}
                          disabled={!isFormValid || ecart === 0}
                        >
                          Valider
                        </Button>
                      )}
                    </div>
                  </Form.Item>
                </Col>
              </Row>
              <Table
                scroll={{ x: true }}
                style={{
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  width: "100%",
                }}
                className="custom-header2-table"
                bordered
                showSorterTooltip={false}
                dataSource={tableData1}
                columns={[
                  {
                    title: "Prestation",
                    dataIndex: "libacte",
                    key: "libacte",
                    sorter: (a, b) => a.libacte.localeCompare(b.libacte),
                  },
                  {
                    title: "Code prest.",
                    dataIndex: "codeprest",
                    key: "codeprest",

                    align: "center",
                    sorter: (a, b) => a.codeprest.localeCompare(b.codeprest),
                  },
                  {
                    title: "Qte.",
                    dataIndex: "qte",
                    key: "qte",
                    align: "center",
                    sorter: (a, b) => a.qte - b.qte,
                    render: (text) => (
                      <div>{formatNumberWithSeparator(text)}</div>
                    ),
                  },
                  {
                    title: "F. réel",
                    dataIndex: "freel",
                    key: "freel",
                    align: "right",
                    sorter: (a, b) => a.freel - b.freel,
                    render: (text) => (
                      <div style={{ paddingRight: 1 }}>
                        {formatNumberWithSeparator(text)}
                      </div>
                    ),
                  },
                  {
                    title: "QP.IPM",
                    dataIndex: "qpmut",
                    key: "qpmut",
                    align: "right",
                    sorter: (a, b) => a.qpmut - b.qpmut,
                    render: (text) => (
                      <div style={{ paddingRight: 1 }}>
                        {formatNumberWithSeparator(text)}
                      </div>
                    ),
                  },
                  {
                    title: "QP.PART",
                    dataIndex: "ticket",
                    key: "ticket",
                    align: "right",
                    sorter: (a, b) => a.ticket - b.ticket,
                    render: (text) => (
                      <div style={{ paddingRight: 1 }}>
                        {formatNumberWithSeparator(text)}
                      </div>
                    ),
                  },
                  {
                    title: "QP. Mut/FS",
                    dataIndex: "qpassur",
                    key: "qpassur",
                    align: "right",
                    sorter: (a, b) => a.qpassur - b.qpassur,
                    render: (text) => (
                      <div style={{ paddingRight: 1 }}>
                        {formatNumberWithSeparator(text)}
                      </div>
                    ),
                  },
                  {
                    title: "F. éxclus",
                    dataIndex: "fexclus",
                    key: "fexclus",
                    align: "right",
                    sorter: (a, b) => a.fexclus - b.fexclus,
                    render: (text) => (
                      <div style={{ paddingRight: 1 }}>
                        {formatNumberWithSeparator(text)}
                      </div>
                    ),
                  },
                  {
                    title: "Ajuste.",
                    dataIndex: "ajustmt",
                    key: "ajustmt",
                    align: "right",
                    sorter: (a, b) => a.ajustmt - b.ajustmt,
                    render: (text) => (
                      <div style={{ paddingRight: 1 }}>
                        {formatNumberWithSeparator(text)}
                      </div>
                    ),
                  },
                  {
                    title: (
                      <div
                        style={{
                          backgroundColor: "#010f1c",
                          color: "white",
                          padding: "1px",
                        }}
                      ></div>
                    ),
                    dataIndex: "actions",
                    key: "actions",
                    align: "center",
                    fixed: "right",
                    render: (text, record) => (
                      <span>
                        <Tooltip title="Modifier">
                          <EditOutlined
                            onClick={() => handleEdit(record)}
                            style={{
                              cursor: "pointer",
                              color: "orange",
                              marginRight: 8,
                            }}
                          />
                        </Tooltip>
                        <Tooltip title="Supprimer">
                          <DeleteFilled
                            onClick={() => handleDelete(record.key)}
                            style={{ cursor: "pointer", color: "red" }}
                          />
                        </Tooltip>
                      </span>
                    ),
                  },
                ]}
                summary={renderSummary}
                footer={() => (
                  <div style={{ textAlign: "right" }}>
                    Quote part IPM:{" "}
                    <strong>
                      {formatNumberWithSeparator(totales.qpmutTotal)}
                    </strong>{" "}
                    / Quote part AGENT:{" "}
                    <strong>
                      {formatNumberWithSeparator(totales.ticketTotal)} CFA
                    </strong>
                    / Quote part Mut:{" "}
                    <strong>
                      {formatNumberWithSeparator(totales.qpassurTotal)} CFA
                    </strong>
                  </div>
                )}
              />
            </Form>
          </DraggableModal>
        </Row>
        <Row gutter={16} style={{ gap: 12 }}>
          <Input
            placeholder="Rechercher..."
            bordered={false}
            style={{ borderBottom: "1px solid #000", width: "200px" }}
            value={searchSecondTableValue}
            onChange={(e) => handleSearch1(e.target.value)}
            onPressEnter={(e) => handleSearch1(e.target.value)}
          />
          <Button
            type="primary"
            icon={<ExclamationCircleOutlined />}
            style={{ borderRadius: 8, boxShadow: "0 2px 4px 0 rgba(0,0,0,0.05)" }}
            onClick={() => handleDisplayAnomaliesFacture(record.numenreg)}
          >
            Afficher Anomalies
          </Button>
          <Table
            rowSelection={rowSelection}
            rowKey="numdoc"
            scroll={{
              x: true,
            }}
            style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
            className="custom-header1-table"
            bordered
            loading={loadingTable1}
            showSorterTooltip={false}
            dataSource={filteredSecondTableData}
            columns={[
              {
                title: "N° Bon/Lettre",
                dataIndex: "numdoc",
                key: "numdoc",
                align: "center",
                sorter: (a, b) => a.numdoc.localeCompare(b.numdoc),
              },
              {
                title: "Date",
                dataIndex: "datedoc",
                key: "datedoc",
                align: "center",
                sorter: (a, b) =>
                  moment(a.datedoc).unix() - moment(b.datedoc).unix(),
                render: (text, record) => (
                  <div
                    style={{
                      whiteSpace: "nowrap",
                      textAlign: "center",
                      paddingLeft: "5px",
                      paddingRight: "5px",
                    }}
                  >
                    {moment(text).locale("fr").format("DD/MM/YYYY")}
                  </div>
                ),
              },
              {
                title: "Mat. Part.",
                dataIndex: "matripart",
                key: "matripart",
                align: "center",
                sorter: (a, b) => a.matripart.localeCompare(b.matripart),
              },
              {
                title: "Participant",
                dataIndex: "participant",
                key: "participant",
                sorter: (a, b) => a.participant.localeCompare(b.participant),
              },
              {
                title: "Type Benef.",
                dataIndex: "typebenef",
                key: "typebenef",
                align: "center",
                sorter: (a, b) => a.typebenef.localeCompare(b.typebenef),
              },
              {
                title: "Beneficiaire",
                dataIndex: "beneficiaire",
                key: "beneficiaire",
                sorter: (a, b) => a.beneficiaire.localeCompare(b.beneficiaire),
              },
              {
                title: "F.Réel",
                dataIndex: "montdoc",
                key: "montdoc",
                align: "right",
                sorter: (a, b) => a.montdoc - b.montdoc,
                render: (text) => (
                  <div style={{ paddingRight: 16 }}>
                    {formatNumberWithSeparator(text)}
                  </div>
                ),
              },
              {
                title: "QP.IPM",
                dataIndex: "qpmut",
                key: "qpmut",
                align: "right",
                sorter: (a, b) => a.qpmut - b.qpmut,
                render: (text) => (
                  <div style={{ paddingRight: 16 }}>
                    {formatNumberWithSeparator(text)}
                  </div>
                ),
              },
              {
                title: "QP PART",
                dataIndex: "ticket",
                key: "ticket",
                align: "right",
                sorter: (a, b) => a.ticket - b.ticket,
                render: (text) => (
                  <div style={{ paddingRight: 16 }}>
                    {formatNumberWithSeparator(text)}
                  </div>
                ),
              },
              {
                title: "QP MUT/ FS",
                dataIndex: "qpassur",
                key: "qpassur",
                align: "right",
                render: (text) => (
                  <div style={{ paddingRight: 16 }}>
                    {formatNumberWithSeparator(text)}
                  </div>
                ),
              },
              {
                title: "Ticket Versé",
                dataIndex: "montverse",
                key: "montverse",
                align: "right",
                sorter: (a, b) => a.montverse - b.montverse,
                render: (text) => (
                  <div style={{ paddingRight: 16 }}>
                    {formatNumberWithSeparator(text)}
                  </div>
                ),
              },
              {
                title: "Frais Exclus",
                dataIndex: "fexclus",
                key: "fexclus",
                align: "right",
                sorter: (a, b) => a.fexclus - b.fexclus,
                render: (text) => (
                  <div style={{ paddingRight: 16 }}>
                    {formatNumberWithSeparator(text)}
                  </div>
                ),
              },
              {
                title: "Écart",
                dataIndex: "ecart",
                key: "ecart",
                align: "right",
                render: (text, record) => {
                  // Calcul de l'écart
                  const ecartValue =
                    (record.montdoc || 0) -
                    (record.qpmut || 0) -
                    (record.ticket || 0) -
                    (record.qpassur || 0);
                  return (
                    <div
                      style={{
                        paddingRight: 16,
                        color: ecartValue !== 0 ? "red" : "green",
                      }}
                    >
                      {formatNumberWithSeparator(ecartValue)}
                    </div>
                  );
                },
                sorter: (a, b) => {
                  const ecartA =
                    (a.montdoc || 0) - (a.qpmut || 0) - (a.ticket || 0) - (a.qpassur || 0);
                  const ecartB =
                    (b.montdoc || 0) - (b.qpmut || 0) - (b.ticket || 0) - (b.qpassur || 0);
                  return ecartA - ecartB;
                },
              },
              {
                title: "Remise",
                dataIndex: "remise",
                key: "remise",
                align: "right",
                sorter: (a, b) => a.remise - b.remise,
                render: (text) => (
                  <div style={{ paddingRight: 16 }}>
                    {formatNumberWithSeparator(text)}
                  </div>
                ),
              },
              {
                title: (
                  <div
                    style={{
                      backgroundColor: "#010f1c",
                      color: "white",
                      padding: "1px",
                    }}
                  ></div>
                ),
                dataIndex: "actions",
                key: "actions",
                align: "center",
                fixed: "right",
                render: (text, record) => (
                  <span>
                    <Tooltip title="Détails">
                      <EyeOutlined
                        style={{
                          cursor: "pointer",
                          color: "green",
                          marginRight: 8,
                        }}
                        onClick={() => showDetailsModal(record)}
                      />
                    </Tooltip>
                  </span>
                ),
              },
            ]}
            pagination={{
              pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
              showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
              pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
              onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
            }}
            summary={renderSummary2}
            footer={() => {
              const freelValue = record?.freel || 0;
              const ecartsecond =
                freelValue - (totalqpmut + totalticket + totalMutuel);
              const nombreDeLignes = secondTableData.length;
              return (
                <span>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Space>
                      <Button
                        className="buttonExport"
                        disabled={selectedRowKeys.length === 0}
                        icon={<UploadOutlined />}
                        onClick={() => handleExport(secondTableData)}
                      >
                        Export Bon
                      </Button>
                      <Button
                        className="buttonRegenere"
                        disabled={selectedRowKeys.length === 0}
                        icon={<UpCircleOutlined />}
                        onClick={() => {
                          Modal.confirm({
                            title: "Confirmer la régénération",
                            icon: <ExclamationCircleOutlined />,
                            content: `Voulez-vous confirmer que vous souhaitez régénérer les ${selectedRowKeys.length} ligne(s) sélectionnée(s) ?`,
                            okText: "Oui",
                            cancelText: "Annuler",
                            onOk: () => regenererLignes(),
                            onCancel: () => {
                              message.info("Régénération annulée.");
                            },
                          });
                        }}
                      >
                        Regénérer
                      </Button>
                      <Button
                        className="buttonExport"
                        disabled={selectedRowKeys.length === 0}
                        icon={<UploadOutlined />}
                        onClick={() => handleExportDetails(detailsData)}
                      >
                        Export Détails Bon
                      </Button>
                    </Space>

                    <div>
                      Total Bons traités:{" "}
                      <strong>
                        {formatNumberWithSeparator(totalMontdoc)} CFA
                      </strong>
                      ({" "}
                      <strong>
                        {formatNumberWithSeparator(nombreDeLignes)}
                      </strong>{" "}
                      - Ecart :
                      <strong>
                        {formatNumberWithSeparator(ecartsecond)} CFA
                      </strong>{" "}
                      )
                    </div>
                  </div>
                </span>
              );
            }}
          />
        </Row>
        <DraggableModal
          width={800}
          style={{ top: 20 }}
          title={`Détails du Bon N° ${selectedRecord ? selectedRecord.numdoc : ""
            }`}
          open={isDetailModalVisible}
          onCancel={() => setIsDetailModalVisible(false)}
          footer={[
            <Button key="back" onClick={() => setIsDetailModalVisible(false)}>
              Fermer
            </Button>,
          ]}
        >
          <Table
            scroll={{
              x: true,
            }}
            style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
            className="custom-header1-table"
            bordered
            showSorterTooltip={false}
            dataSource={detailsData}
            columns={[
              {
                title: "Prestation",
                dataIndex: "libacte",
                key: "libacte",
                sorter: (a, b) => a.libacte.localeCompare(b.libacte),
              },
              {
                title: "Qte.",
                dataIndex: "qte",
                key: "qte",
                align: "center",
                sorter: (a, b) => a.qte - b.qte,
              },
              {
                title: "F. réel",
                dataIndex: "freel",
                key: "freel",
                align: "right",
                sorter: (a, b) => a.freel - b.freel,
              },
              {
                title: "QP.IPM",
                dataIndex: "qpmut",
                key: "qpmut",
                align: "right",
                sorter: (a, b) => a.qpmut - b.qpmut,
              },
              {
                title: "QP.PART",
                dataIndex: "ticket",
                key: "ticket",
                align: "right",
                sorter: (a, b) => a.ticket - b.ticket,
              },
              {
                title: "QP. Assur",
                dataIndex: "qpassur",
                key: "qpassur",
                align: "right",
                sorter: (a, b) => a.qpassur - b.qpassur,
              },
              {
                title: "Ajuste.",
                dataIndex: "ajustmt",
                key: "ajustmt",
                align: "right",
                sorter: (a, b) => a.ajustmt - b.ajustmt,
              },
              {
                title: "F. éxclus",
                dataIndex: "fexclus",
                key: "fexclus",
                align: "right",
                sorter: (a, b) => a.fexclus - b.fexclus,
              },
            ]}
            rowKey="numdoc" // Assurez-vous que chaque ligne a un identifiant unique
            pagination={{
              pageSize: 5, // le nombre d'éléments par page
            }}
          />
        </DraggableModal>
      </Card>
      <Modal
        title="Importation Bon"
        open={isImportModalOpen}
        width={800}
        onCancel={handleImportModalClose}
        footer={[
          <Button key="cancel" onClick={handleImportModalClose}>
            Annuler
          </Button>,
          <Button
            key="import"
            type="primary"
            disabled={importedData.length === 0}
            onClick={handleImportSubmit}
          >
            Importer
          </Button>,
        ]}
      >
        <input
          type="file"
          accept=".xlsx, .xls"
          onChange={handleFileChange}
          ref={fileInputRef}
        />
        <Table
          bordered
          scroll={{
            y: 55 * 5,
          }}
          showSorterTooltip={false}
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          className="custom-header1-table"
          dataSource={importedData}
          columns={[
            {
              title: "N° doc.",
              dataIndex: "NumDoc",
              key: "numdoc",
              render: (text) => <div style={{ padding: "8px" }}>{text}</div>,
            },
            {
              title: "Ref. Medoc",
              dataIndex: "Ref_Medoc",
              key: "ref_medoc",
              render: (text) => <div style={{ padding: "8px" }}>{text}</div>,
            },
            { title: "Libellé", dataIndex: "Libelle", key: "libacte" },
            {
              title: "Nb. article",
              dataIndex: "NB_article",
              key: "nb_article",
              align: "right",
              render: (text) => <div style={{ padding: "8px" }}>{text}</div>,
            },
            {
              title: "Montant",
              dataIndex: "Montant",
              key: "montant",
              align: "right",
              render: (text) => (
                <div style={{ padding: "8px" }}>
                  <strong>{formatNumberWithSeparator(text)}</strong>
                </div>
              ),
            },
            {
              title: "QP. MUT.",
              dataIndex: "qpmut",
              key: "qpmut",
              align: "right",
              render: (text) => (
                <div style={{ padding: "8px" }}>
                  <strong>{formatNumberWithSeparator(text)}</strong>
                </div>
              ),
            },
          ]}
          pagination={false}
          rowKey={(record) => `${record["NumDoc"]}-${record["Ref Medic"]}`}
          summary={() => (
            <Table.Summary.Row>
              <Table.Summary.Cell colSpan={4}>
                Total Lignes:{" "}
                <strong>{formatNumberWithSeparator(totals.totalLines)}</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell>
                Total calculé:{" "}
                <strong>
                  {formatNumberWithSeparator(totals.totalCalculated)}
                </strong>{" "}
                CFA
              </Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        />
      </Modal>
    </div>
  );
};

export default TraitementFacture;
